import React from 'react';

interface SelectedTopicsCounterProps {
  total: number;
  lightTheme?: boolean;
  filtersAreOpen?: boolean;
  additionalClasses?: string;
}

const SelectedTermsCounter = ({
  total,
  lightTheme = false,
  filtersAreOpen = false,
  additionalClasses = '',
}: SelectedTopicsCounterProps) => {
  const themeClasses = lightTheme
    ? `text-[#3722D3] ${filtersAreOpen ? 'bg-[#3722D3] text-white' : 'bg-white'}`
    : 'bg-[#3722D3] text-white';

  const textSizeClass =
    total > 9 ? 'text-[12px] leading-[22px]' : 'text-[13px] leading-[21px]';

  return (
    <span
      className={`inline-block topic-filter__total_selected w-[21px] h-[21px] overflow-hidden rounded-[12px] text-center font-bold ${themeClasses} ${textSizeClass} ${additionalClasses}`}
    >
      {total}
    </span>
  );
};

export default SelectedTermsCounter;
